var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StoryCategories',{staticClass:"StoryCategoriesHome"}),_c('slider'),(
        _vm.$store.getters['front/getHomeData'] != null &&
        _vm.$store.getters['front/getHomeData'].flashes != ''
      )?_c('Flashes',{attrs:{"flashes":_vm.$store.getters['front/getHomeData'].flashes}}):_vm._e(),_c('AmazingProduct'),_c('main',{staticClass:"main container container-2 pt-1 p-sm-5"},[_c('div'),_c('Banners',{attrs:{"banners":_vm.banners[0]}}),_c('RecommendedProduct'),_c('Banners',{attrs:{"banners":_vm.banners[1]}}),_c('Weblogs')],1),_c('resiveHome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }